// The claims in a Firebase ID token, read in the browser without verifying it
// (the API verifies; this only decides what to render).
//
// A JWT is base64url: `-` and `_` where atob expects `+` and `/`, and no
// padding. A bare `atob(token.split('.')[1])` throws as soon as the payload
// encodes to either character, which a Thai or accented display name almost
// always does. The guards caught that and read it as "no role", so an admin
// named สมชาย ใจดี was sent away from every admin page.
//
// The decoded bytes are UTF-8, so the name comes back as written.

export const decodeJwtPayload = (token) => {
  if (!token || typeof token !== 'string') return null;
  const part = token.split('.')[1];
  if (!part) return null;
  try {
    const base64 = part.replace(/-/g, '+').replace(/_/g, '/');
    const binary = atob(base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '='));
    const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
    return JSON.parse(new TextDecoder().decode(bytes));
  } catch {
    return null;
  }
};
